<template>
    <div>
        <Container >
            <div class="py-8 grid grid-cols-1 lg:grid-cols-3 lg:gap-16 z-50 px-8 lg:px-0">
                <div class="col-span-2">
                    <p class="text-lg lg:text-6xl font-bold">{{ heading }}</p>
                    <h2 class="lg:text-3xl mt-2 font-semibold">{{ subHeading }}</h2>
                    <div class="lg:mt-8 text-2xl lg:max-w-xl">
                        {{ paragraph }}
                    </div>
                    <div class="mt-8 w-40">
                        <a :href="ctaUrl" class="text-contrast-500 bg-[#E2734A] hover:bg-[#E2734A] hover:scale-105 px-4 py-3 rounded-xl duration-150 shadow-sm font-semibold  flex items-center justify-center">{{ ctaLabel }}</a>
                        <!-- <PrimaryButton class="text-contrast-500 bg-[#E2734A] hover:bg-[#E2734A] hover:scale-105" :href="ctaUrl">{{ ctaLabel }}</PrimaryButton> -->
                    </div>
                </div>
                <div class="hidden lg:block col-span-1">
                    <div class="aspect-square w-full">
                        <img :src="imageSrc" alt="Avatar" class="w-full h-full object-contain" />
                    </div>
                </div>
            </div>
        </Container>
    </div>

    <div class="w-full" :style="`background-color:${waveColor2}`">

        <svg class="w-full" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1280 129.967">
            <g id="Group_1" data-name="Group 1" transform="translate(0 -353)">
                <path id="Path_2" data-name="Path 2" d="M500,448.5C236.157,521.739,74.407,479.59,0,434.232V400.29H1280v61.957C973.5,659,829.8,356.951,500,448.5Z" transform="translate(0 -47.29)" :fill="waveColor1"/>
                <path id="Path_1" data-name="Path 1" d="M500,548.5C236.157,621.739,74.407,553.358,0,508H1280v54.247C969.5,742,829.8,456.951,500,548.5Z" transform="translate(0 -155)" fill="#fff"/>
            </g>
        </svg>




        <div class="pt-16 pb-32 px-8 lg:px-0">
            <Container >
                <h2 class="text-2xl font-bold">
                    Our Resources
                </h2>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-4">
                    <div v-for="card in cards" class="rounded-lg shadow p-4 spae-y-2 bg-white">
                        <div class="w-12 h-12 rounded-full flex items-center justify-center p-1" :style="`background-color:${card.iconBackgroundColor}`">
                            <div class="w-6 h-6" v-html="card.iconSvg" :style="`color:${card.iconColor}`" />
                        </div>
                        <h3 class="font-bold mt-4 text-xl">{{ card.title }}</h3>
                        <a :href="card.ctaUrl" class="block mt-4 font-semibold flex items-center space-x-2">
                            <h4>{{ card.ctaLabel }}</h4>
                            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 12L8.6 10.55L12.15 7H0V5H12.15L8.6 1.45L10 0L16 6L10 12Z" fill="#1C1B1F"/>
                            </svg>

                        </a>
                    </div>
                </div>
            </Container>
        </div>
    </div>




</template>

<script>
import Container from '../../../Layouts/Container.vue'
export default {
    components: {
        Container,
    },
    props: {
        heading: {
            type: String,
            default: ''
        },
        subHeading: {
            type: String,
            default: ''
        },
        paragraph: {
            type: String,
            default: '',

        },
        ctaLabel: {
            type: String,
            default: ''
        },
        ctaUrl: {
            type: String,
            default: '#'
        },
        imageSrc: {
            type: String,
            default: ''
        },
        waveColor1: {
            type: String,
            default: null
        },
        waveColor2: {
            type: String,
            default: null
        },
        cards: {
            type: Array,
            default: []
        }
    }
}
</script>
